import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { logOut } from '../util';
import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer, Tooltip } from 'recharts';
import Title from '../text/title';

const CustomTooltip = () => <div>Return Rate</div>;

export default function ScanCountChart({ token, setToken }) {
    const [data, setData] = useState(false);
    let navigate = useNavigate()
    const theme = useTheme();

    useEffect(() => {
        let status;
        let threeMonthsAgo = dayjs().subtract(3, 'm').startOf('d').valueOf();

        fetch('/api/stats/scans/count?'
            + new URLSearchParams({
                bucketBy: 'day'
            }),
            {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                },
                // body: JSON.stringify(filter)
            })
            .then(response => {
                status = response.status;
                return response.json();
            })
            .then(json => {
                if (status !== 200) {
                    if (status === 401) {
                        return logOut({ navigate, setToken })
                    }
                }

                json.forEach(timePeriod => {
                    if (timePeriod.dayOfMonth !== null) {
                        if (timePeriod.dayOfMonth === 1) {
                            timePeriod.chartName = dayjs().month(timePeriod.month - 1).format('MMM')
                        } else {
                            // dayjs days are 0-indexed
                            timePeriod.chartName = timePeriod.dayOfMonth
                            // timePeriod.chartName = dayjs().year(timePeriod.year).month(timePeriod.month - 1).date(timePeriod.dayOfMonth - 1).format('ddd')
                        }
                    } else if (timePeriod.month !== null) {
                        if (timePeriod.month === 1) {
                            timePeriod.chartName = timePeriod.year
                        } else {
                            // dayjs months are 0-indexed
                            timePeriod.chartName = dayjs().month(timePeriod.month - 1).format('MMM')
                        }
                    }
                })

                setData(json);
            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    return (
        <React.Fragment>
            <Title>Scans</Title>
            <ResponsiveContainer height={'85%'}>
                <LineChart
                    data={data}
                    margin={{
                        top: 16,
                        right: 16,
                        bottom: 0,
                        // left: 24,
                    }}
                >
                    <XAxis
                        dataKey="chartName"
                        stroke={theme.palette.text.secondary}
                        style={theme.typography.body2}
                    />
                    <YAxis
                        stroke={theme.palette.text.secondary}
                        style={theme.typography.body2}
                        tickFormatter={tick => `${tick}`}
                        domain={[0, dataMax => Math.max(dataMax, 4)]}
                    >
                    </YAxis>
                    <Line
                        isAnimationActive={true}
                        type="monotone"
                        dataKey="scans"
                        stroke={theme.palette.primary.main}
                        dot={false}
                    />
                    <Tooltip contentStyle={{backgroundColor: theme.palette.background.paper}} />
                </LineChart>
            </ResponsiveContainer>
        </React.Fragment>
    );
}